/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { FileImportHistoryPageDto } from '../models';
// @ts-ignore
import type { FileImportReportDto } from '../models';
/**
 * RestFileImportsApi - axios parameter creator
 */
export const RestFileImportsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Delete an imported file from the history; the dishes and sets it imported stay
         * @param {string} fileImportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFileImport: async (fileImportId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileImportId' is not null or undefined
            assertParamExists('deleteFileImport', 'fileImportId', fileImportId)
            const localVarPath = `/api/files-import/history/{fileImportId}`
                .replace('{fileImportId}', encodeURIComponent(String(fileImportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Download an imported file
         * @param {string} fileImportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadImportedFile: async (fileImportId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileImportId' is not null or undefined
            assertParamExists('downloadImportedFile', 'fileImportId', fileImportId)
            const localVarPath = `/api/files-import/history/{fileImportId}/file`
                .replace('{fileImportId}', encodeURIComponent(String(fileImportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List imported files, newest first
         * @param {number} page 
         * @param {number} pageSize 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFileImportHistory: async (page: number, pageSize: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('getFileImportHistory', 'page', page)
            // verify required parameter 'pageSize' is not null or undefined
            assertParamExists('getFileImportHistory', 'pageSize', pageSize)
            const localVarPath = `/api/files-import/history`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the import report of an imported file
         * @param {string} fileImportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFileImportReport: async (fileImportId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileImportId' is not null or undefined
            assertParamExists('getFileImportReport', 'fileImportId', fileImportId)
            const localVarPath = `/api/files-import/history/{fileImportId}/report`
                .replace('{fileImportId}', encodeURIComponent(String(fileImportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RestFileImportsApi - functional programming interface
 */
export const RestFileImportsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RestFileImportsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Delete an imported file from the history; the dishes and sets it imported stay
         * @param {string} fileImportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteFileImport(fileImportId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteFileImport(fileImportId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestFileImportsApi.deleteFileImport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Download an imported file
         * @param {string} fileImportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadImportedFile(fileImportId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadImportedFile(fileImportId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestFileImportsApi.downloadImportedFile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List imported files, newest first
         * @param {number} page 
         * @param {number} pageSize 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFileImportHistory(page: number, pageSize: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileImportHistoryPageDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFileImportHistory(page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestFileImportsApi.getFileImportHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get the import report of an imported file
         * @param {string} fileImportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFileImportReport(fileImportId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileImportReportDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFileImportReport(fileImportId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestFileImportsApi.getFileImportReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RestFileImportsApi - factory interface
 */
export const RestFileImportsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RestFileImportsApiFp(configuration)
    return {
        /**
         * 
         * @summary Delete an imported file from the history; the dishes and sets it imported stay
         * @param {string} fileImportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFileImport(fileImportId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteFileImport(fileImportId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Download an imported file
         * @param {string} fileImportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadImportedFile(fileImportId: string, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.downloadImportedFile(fileImportId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List imported files, newest first
         * @param {number} page 
         * @param {number} pageSize 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFileImportHistory(page: number, pageSize: number, options?: RawAxiosRequestConfig): AxiosPromise<FileImportHistoryPageDto> {
            return localVarFp.getFileImportHistory(page, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the import report of an imported file
         * @param {string} fileImportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFileImportReport(fileImportId: string, options?: RawAxiosRequestConfig): AxiosPromise<FileImportReportDto> {
            return localVarFp.getFileImportReport(fileImportId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RestFileImportsApi - interface
 */
export interface RestFileImportsApiInterface {
    /**
     * 
     * @summary Delete an imported file from the history; the dishes and sets it imported stay
     * @param {string} fileImportId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteFileImport(fileImportId: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Download an imported file
     * @param {string} fileImportId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    downloadImportedFile(fileImportId: string, options?: RawAxiosRequestConfig): AxiosPromise<File>;

    /**
     * 
     * @summary List imported files, newest first
     * @param {number} page 
     * @param {number} pageSize 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getFileImportHistory(page: number, pageSize: number, options?: RawAxiosRequestConfig): AxiosPromise<FileImportHistoryPageDto>;

    /**
     * 
     * @summary Get the import report of an imported file
     * @param {string} fileImportId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getFileImportReport(fileImportId: string, options?: RawAxiosRequestConfig): AxiosPromise<FileImportReportDto>;

}

/**
 * RestFileImportsApi - object-oriented interface
 */
export class RestFileImportsApi extends BaseAPI implements RestFileImportsApiInterface {
    /**
     * 
     * @summary Delete an imported file from the history; the dishes and sets it imported stay
     * @param {string} fileImportId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteFileImport(fileImportId: string, options?: RawAxiosRequestConfig) {
        return RestFileImportsApiFp(this.configuration).deleteFileImport(fileImportId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Download an imported file
     * @param {string} fileImportId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public downloadImportedFile(fileImportId: string, options?: RawAxiosRequestConfig) {
        return RestFileImportsApiFp(this.configuration).downloadImportedFile(fileImportId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List imported files, newest first
     * @param {number} page 
     * @param {number} pageSize 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getFileImportHistory(page: number, pageSize: number, options?: RawAxiosRequestConfig) {
        return RestFileImportsApiFp(this.configuration).getFileImportHistory(page, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the import report of an imported file
     * @param {string} fileImportId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getFileImportReport(fileImportId: string, options?: RawAxiosRequestConfig) {
        return RestFileImportsApiFp(this.configuration).getFileImportReport(fileImportId, options).then((request) => request(this.axios, this.basePath));
    }
}

